import { Typography } from "@material-tailwind/react";

export function Footer() {
  return (
    <footer className="flex w-full flex-row flex-wrap items-center justify-center gap-y-6 gap-x-12  py-6 text-center md:justify-center">
      <Typography color="white" className="font-normal font-tajawal ">
        &copy; 2024{" "}
        <a href="https://alayadids.com/">Alayadi Digital Solutions</a>
      </Typography>
    </footer>
  );
}
